import React from "react";
import { useNavigate } from "react-router-dom";

const AdministrativeConsole = () => {
  const navigate = useNavigate();

  return (
    <section className="menu-section-bg">
      <div className="menu-container">

        {/* ===== HEADER ===== */}
        <div className="product-subtitleBg-header">
          <h1 className="product-titleBg">Administrative Console</h1>
          <p className="product-subtitleBg">
            A centralized control panel for administrators to manage users,
            roles, permissions, system configurations, and institutional
            operations with complete visibility and control.
          </p>
        </div>

        {/* ===== OVERVIEW ===== */}
        <div className="product-and-sol-mainCard ps-two-column-grid product-sol-card">

          <div>
            <h2 className="product-and-sol-sectionTitle">
              Centralized Administrative Control
            </h2>
            <p className="product-and-sol-section-text">
              The Administrative Console empowers leadership and IT teams to
              configure system settings, manage users, define policies, and
              monitor platform activity from a single secure interface.
            </p>

            <ul className="product-and-sol-list">
              <li>✔ User & role management</li>
              <li>✔ Permission & access control</li>
              <li>✔ Institution & session settings</li>
              <li>✔ Audit logs & activity tracking</li>
            </ul>
          </div>

          <div className="enrollment-image-card product-sol-card-imageBox">
            <img
              src="../images/product&soluction/academicmanagement.jpg"
              alt="Administrative Dashboard"
              className="ps-main-image"
            />
          </div>

        </div>

        {/* ===== FEATURES ===== */}
        <div className="ps-feature-grid">

          <FeatureCard
            typeClass="credentialing"
            backgroundColor="#e9fdf3"
            icon={icons.users}
            title="User & Role Management"
            description="Create, manage, and assign roles to administrators, teachers, staff, students, and parents."
          />

          <FeatureCard
            typeClass="wallet"
            backgroundColor="#f3ecff"
            icon={icons.permissions}
            title="Access & Permissions"
            description="Define granular permissions so users access only what they are authorized to."
          />

          <FeatureCard
            typeClass="human-resources"
            backgroundColor="#f1f6ff"
            icon={icons.settings}
            title="System Configuration"
            description="Configure academic sessions, grading systems, workflows, and institutional policies."
          />

          <FeatureCard
            typeClass="education"
            backgroundColor="#fff3cc"
            icon={icons.monitoring}
            title="Activity Monitoring"
            description="Track system activity, login history, and administrative actions with audit logs."
          />

          <FeatureCard
            typeClass="marketing"
            backgroundColor="#ffe6dc"
            icon={icons.security}
            title="Security & Compliance"
            description="Ensure data protection with secure authentication, access logs, and compliance controls."
          />

          <FeatureCard
            typeClass="analytics"
            backgroundColor="#eaf9fa"
            icon={icons.backup}
            title="Backup & Data Management"
            description="Manage data backups, exports, and recovery to maintain system reliability."
          />

        </div>

        {/* ===== CTA / HIGHLIGHT SECTION ===== */}
        <div className="ps-highlight-wrapper">
          <div className="ps-highlight-card">

            <div className="ps-highlight-header">
              <h2 className="ps-highlight-title">
                Operate with Confidence & Control
              </h2>
              <p className="ps-highlight-subtitle">
                Powerful administrative tools for modern institutions
              </p>
            </div>

            <div className="ps-highlight-body">
              <p className="ps-highlight-text">
                Give administrators everything they need to manage operations
                efficiently, securely, and at scale.
              </p>

              <div className="ps-button-group">
                <button
                  className="Demo-button"
                  onClick={() => navigate("/contact#Contact-form")}
                >
                  Request Admin Demo
                </button>
              </div>
            </div>

          </div>
        </div>

      </div>
    </section>
  );
};

/* ===== SHARED FEATURE CARD ===== */
const FeatureCard = ({
  icon,
  title,
  description,
  backgroundColor,
  typeClass
}) => (
  <div
    className={`card product-soluction-card ${typeClass}`}
    style={{ backgroundColor }}
  >
    <div className="card-overlay"></div>

    <div className="circle">
      <div className="ps-card-icon">{icon}</div>
    </div>

    <h3 className="ps-card-title">{title}</h3>
    <p className="product-soluction-card-text">{description}</p>
  </div>
);

/* ===== ICONS ===== */
const icons = {
  users: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <circle cx="9" cy="7" r="4" stroke="#5a5cff" strokeWidth="2" />
      <circle cx="17" cy="9" r="3" stroke="#5a5cff" strokeWidth="2" />
      <path d="M3 21c0-4 12-4 12 0M13 21c0-3 8-3 8 0" stroke="#5a5cff" strokeWidth="2" />
    </svg>
  ),
  permissions: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <rect x="4" y="4" width="16" height="16" rx="3" stroke="#ff8c00" strokeWidth="2" />
      <path d="M8 12h8M12 8v8" stroke="#ff8c00" strokeWidth="2" />
    </svg>
  ),
  settings: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="3" stroke="#0ca85c" strokeWidth="2" />
      <path
        d="M19.4 15a1.7 1.7 0 0 0 .34 1.87l.04.04a2 2 0 1 1-2.83 2.83l-.04-.04
        a1.7 1.7 0 0 0-1.87-.34 1.7 1.7 0 0 0-1 1.52V21a2 2 0 0 1-4 0v-.06
        a1.7 1.7 0 0 0-1-1.52 1.7 1.7 0 0 0-1.87.34l-.04.04a2 2 0 1 1-2.83-2.83l.04-.04
        A1.7 1.7 0 0 0 5 15a1.7 1.7 0 0 0-1.52-1H3a2 2 0 0 1 0-4h.06
        A1.7 1.7 0 0 0 5 8.48a1.7 1.7 0 0 0-.34-1.87l-.04-.04a2 2 0 1 1
        2.83-2.83l.04.04A1.7 1.7 0 0 0 8.48 5a1.7 1.7 0 0 0 1.52-1V3
        a2 2 0 0 1 4 0v.06A1.7 1.7 0 0 0 15.52 5a1.7 1.7 0 0 0
        1.87-.34l.04-.04a2 2 0 1 1 2.83 2.83l-.04.04A1.7 1.7 0 0 0
        19 8.48"
        stroke="#0ca85c"
        strokeWidth="1.8"
      />
    </svg>
  ),
  monitoring: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <path d="M3 12s4-6 9-6 9 6 9 6-4 6-9 6-9-6-9-6z"
        stroke="#e74c3c" strokeWidth="2" />
      <circle cx="12" cy="12" r="3"
        stroke="#e74c3c" strokeWidth="2" />
    </svg>
  ),
  security: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <path d="M12 3l8 4v6c0 5-3.5 7.5-8 9-4.5-1.5-8-4-8-9V7l8-4z"
        stroke="#6c5ce7" strokeWidth="2" />
    </svg>
  ),
  backup: (
    <svg width="40" height="40" viewBox="0 0 24 24" fill="none">
      <path d="M12 4a6 6 0 0 1 6 6v1h1a3 3 0 1 1 0 6H7a4 4 0 1 1 0-8h1"
        stroke="#0097e6" strokeWidth="2" />
      <path d="M12 10v6M9 13l3-3 3 3"
        stroke="#0097e6" strokeWidth="2" />
    </svg>
  ),
};

export default AdministrativeConsole;
